import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppService } from '@app/app.service';
import { TestCarPageService } from '@pages/test-car-page/test-car-page.service';

import { TestCarPageInterface } from '../adapter/test-car-page-adapter';

@Injectable({
  providedIn: 'root',
})
export class TestCarPageResolver implements Resolve<Observable<TestCarPageInterface | null>> {
  private testCarPageService = inject(TestCarPageService);
  private router = inject(Router);
  private appService = inject(AppService);

  public resolve(route: ActivatedRouteSnapshot): Observable<TestCarPageInterface | null> {
    const testCarSectionId = route.paramMap.get('testCarSectionId');
    this.appService.lightBackgroundPage();

    return this.testCarPageService.getTestCarPage(testCarSectionId).pipe(
      map((result) => {
        if (!result) {
          this.router.navigate(['404'], { skipLocationChange: true });
          return null;
        } else {
          return result;
        }
      })
    );
  }
}
